<!--檢查前評估-->
<div class="page-container reserve-confirm-content">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">{{ 'reserve-confirm-survey.title' | translate }}</h2>
    <div class="page-subtitle-block">
      <img width="26" height="26" ngSrc="assets/img/i-clock-user.svg" alt="clock-user" />
      <div>
        <p class="page-subtitle-block-title">
          {{ 'reserve-confirm-survey.hint-title' | translate }}
        </p>
        <p>{{ 'reserve-confirm-survey.hint-message' | translate }}</p>
      </div>
    </div>
  </div>

  @for (
    indicationInfo of indicationInfoList;
    let i = $index;
    track indicationInfo.questionnaireTypeId
  ) {
    <div class="card-content register-card-content">
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title subtitle-item">
          <!-- {{ indicationInfo.examItemList[0].examName }} -->
            {{ indicationInfo.questionnaireTypeName }}
          @if (indicationInfo.questionList.length > 1) {
            <span class="register-card-subtitle">{{
              'reserve-confirm-survey.current-symptoms-checked' | translate
            }}</span>
          } @else {
            <span class="register-card-subtitle">{{
              'reserve-confirm-survey.current-symptoms' | translate
            }}</span>
          }
        </h3>

        @if (showError && !isIndicationValid(indicationInfo, i)) {
          <div class="input-block subtitle-error-msg" #errorMsg>
            <mat-error class="input-error-msg">{{
              'error.survey-question-error.required' | translate
            }}</mat-error>
          </div>
        }

        <div class="input-block">
          <mat-checkbox
            [(ngModel)]="nonOfFollowings[i]"
            (change)="toggleNonOfFollowing(i)"
            >{{ 'reserve-health.none-of-following' | translate }}
          </mat-checkbox>
        </div>
      </div>

      <div class="questionnaire-content">
        @for (
          question of indicationInfo.questionList;
          track question.questionId
        ) {
          <div class="input-block step-input-block">
            <section class="mat-mdc-checkbox-group">
              <mat-checkbox
                [checked]="
                  questionAnswerMap.get(indicationInfo.questionnaireTypeId + '-' + question.questionId) === API_PARAMS.YES
                "
                (change)="
                  toggleChoice($event.checked, indicationInfo, question, i)
                "
                [disabled]="nonOfFollowings[i]"
              >
                {{ question.questionName }}
              </mat-checkbox>
              @if (question.questionName.includes(BMI)) {
                <div class="input-calculator-msg" [class.disabled]="nonOfFollowings[i]">
                  <img width="14" height="14" ngSrc="assets/img/i-info.svg" alt="" />
                  <span class="bmi-calculator" (click)="!nonOfFollowings[i] && openBmiCalculator(question)">
                    {{'reserve-confirm-survey.bmi-calulator' | translate}}
                  </span>
                </div>
              }
            </section>
          </div>
        }
      </div>
    </div>
  }

  <!--頁面：固定按鈕區塊-->
  <div class="page-btn-block">
    <button
      mat-button
      (click)="previous()"
      class="btn-outline-primary btn-size-l"
      [disabled]="isEligibilitySaveFailed"
    >
      {{ 'common.button.previous' | translate }}
    </button>
    <button mat-button (click)="next()" class="btn-fill-primary btn-size-l" [disabled]="isEligibilitySaveFailed">
      {{ 'common.button.next' | translate }}
    </button>
  </div>
</div>
